import React from "react";
import { createRoot, type Root } from "react-dom/client";
import App from "./App";
import { setContentLocaleChangeHandler } from "./utils/contentLocaleChangeHandler";

// We need to load our index.scss file in development because we don't want to have to
// call out to the branding service for a specific sha that may not exist while developing
if (import.meta.env.DEV) {
  await import("./_styles/index.scss");
}

const renderApp = (generation: number) => {
  if (root) root.unmount();
  root = createRoot(document.getElementById("root")!);
  root.render(<App key={generation} />);
};

let root: Root | null = null;

// Bumped on every Locale change and used as <App>'s React key, so a rebuild
// throws the old tree away instead of re-rendering it in place with the UI
// state - open dropdowns, scroll position, expanded panels - it had.
let renderGeneration = 0;
renderApp(renderGeneration);

setContentLocaleChangeHandler(() => {
  renderGeneration += 1;
  renderApp(renderGeneration);
});
